

$(".product-form__cart-submit").click(function () {

  var isVendor = 0;
  var isUa = 0;
  var isRamen = 0;
  var isSnows = 0;
  var isOther = 0;
  var countVendor = 0;
  var checkQuantity = 0;
  var isSnowsYamato = 0;
  var add_item = "";
  var sku_noshi_size = "";
  var isSnowsShopper = 0;

  let variant_id = $(this).attr("variant_id");

  var item_max = 100;
  if($(this).attr("item_max")[0]) {
    item_max = $(this).attr("item_max");
  }

  // console.log(item_max);
  

  $.ajax({
    type: 'POST',
    url: '/cart.js',
    async: false,
    dataType: 'json'
  }).done(function (data) {

 

    var quantity = 0;
    for (var k = 0; k <= data.items.length - 1; k++) {
      var vendor = data.items[k]["vendor"];
      var handle = data.items[k]["handle"];
      var title = data.items[k]["title"];
      // console.log("vendor=" + vendor);
      // console.log("title=" + title);
            
      if (vendor == "UTOPIA AGRICULTURE STORE") {
        isVendor = 1;
        isUa = 1;
      } else if (vendor == "RAMEN CLUB") {
        quantity = quantity + data.items[k]["quantity"];
        var addQuantity = $(".counter__num").val();
        isVendor = 1;
        checkQuantity = Number(addQuantity) + Number(quantity);
        if (6 <= Number(data.item_count)) {
          btnSoldoutTextMessage = "【数量制限】計6箱以内としてください。";
          errStr = btnSoldoutTextMessage;

        } else if ((6 + 1) <= checkQuantity) {
          btnSoldoutTextMessage = "【数量制限】計6箱以内としてください。"; // 2 checkQuantity=" + checkQuantity;
          errStr = btnSoldoutTextMessage;

        }
        isRamen = 1;
      } else if (handle.indexOf('yamato') !== -1) {
        isSnowsYamato = 1;
      } else if (vendor == "snows") {
        isVendor = 1;
        isSnows = 1;
        if(title.indexOf('ショッパー') !== -1){
          isSnowsShopper = 1;
        }else{
          isSnowsShopper = 0;
        }
      } else {
        isOther = 1;

        // console.log(data.items[k]["quantity"]); // ["id"]
        if (data.items[k]["id"] == variant_id) {
          quantity = data.items[k]["quantity"];
          var addQuantity = $(".counter__num").val();
                checkQuantity = Number(addQuantity) + Number(quantity);
                // console.log("-------checkQuantity=" + checkQuantity);
                if ((Number(item_max) + 1) <= Number(checkQuantity)) {
                  btnSoldoutTextMessage = "【数量制限】本商品は、" + item_max + "個まで購入可能です。";
                  errStr = btnSoldoutTextMessage;
                }
              }
             
            }
          }

          //console.log("-------errStr=" + errStr + ", item_max=" + item_max + ", checkQuantity="+ checkQuantity);
          var thisVendor = $(".thisVendor").attr("thisVendor");

          if (thisVendor == "RAMEN CLUB") {
            isRamen = 1;
          } else if (thisVendor == "UTOPIA AGRICULTURE STORE") {
            isUa = 1;


          } else if (thisVendor == "snows" && isSnowsYamato == 0) {
            isSnows = 1;

          } else {
            isOther = 1;
          }
          countVendor = Number(isUa) + Number(isRamen) + Number(isSnows) + Number(isOther) + Number(isSnowsYamato);
          //console.log("countVendor=" + countVendor + ", isVendor=" + isVendor + ", errStr=" + errStr);

        });
        if (isSnows == 1 && isSnowsYamato == 1) {
          $(".err_area").show();
          $(".err_area").html("ヤマト様専用商品は、他商品と同時購入出来ません。");
          //console.log("他ブランド商品は購入出来ません。");
          return 1;
        }
        if (countVendor != 1) {
          if(isSnows == 1 && isSnowsShopper == 1){
              // 
                $.ajax({
                  type: 'POST',
                  url: '/cart/clear.js',
                  async: false,
                  dataType: 'json'
                }).done(function (data) {
                  console.log(data);
                });
          }else{
            $(".err_area").show();
            $(".err_area").html("他ストアの商品とは一緒に購入できません。<br>現在のカートを空にしてください。");
            //console.log("他ブランド商品は購入出来ません。");
            return 1;

          }

        }


 
  var formData = null;
  var properties = [];
  properties["properties"] = {};

    let date = new Date();
    let timestamp = Math.floor(date.getTime() / 1000);

    console.log("variant_id:" + variant_id);
    var temp = { "id": variant_id, "quantity": 1 };
    temp = Object.assign(temp, properties);
    formData = {
      items: [temp]
    };

    let response = fetch('/cart/add.js?timestamp=' + timestamp, {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then(data => {
        console.log(data.items);
        $(".cart-popup-wrapper").show();
                $(".cart-popup-item__title").html(data.items[0].title);
                $(".cart-popup-item__image").attr("src", data.items[0].image);
      }).catch(error => {
        console.error('Error:', error);
      });
});
$(".cart-popup__close").click(function () {
  $(".cart-popup-wrapper").hide();
});
